/**
 * This will bind an event listener to the modal helper popup, which will add a loading spinner to the item you click on the last step.
 * This will indicate to the user that something is generating and they should wait.
 */

class ModalHelperWatcher {
    constructor() {
        this.init = this.init.bind(this);

        this.init();
    }

    init() {
        const modal = document.querySelector('.needhelp-modal');
        const buttons = document.querySelectorAll('.needhelp-modal #needhelp-item-7 div.item');
        buttons.forEach(button => {
            button.addEventListener('click', () => {
                modal.classList.add('loading');
            });
        });
    }
}

if (document.querySelector('.needhelp-modal')) new ModalHelperWatcher();
export default ModalHelperWatcher;
